// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__28r0Q","choiceBoxes":"toolbarselects_choiceBoxes__vMqA9","simpleField":"toolbarselects_simpleField__1ZwNR"};